import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M108 41.87C108 41.87 80.37 27.42 78.97 25.66C77.57 23.9 76.63 1 76.63 1H54.62C54.62 1 53.68 23.9 52.28 25.66C50.88 27.42 23.25 41.87 23.25 41.87C23.25 41.87 35.5 56.92 65.63 56.92C95.76 56.92 108 41.87 108 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.72 47.5701C118.64 43.9401 84.08 26.7601 84.08 26.7601L78.95 17.1801L65.62 24.72L52.29 17.1801L47.16 26.7601C47.16 26.7601 12.6 43.9301 9.52 47.5701C6.44 51.2001 2 72.3401 2 72.3401H129.23C129.24 72.3401 124.79 51.2001 121.72 47.5701Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M84.0799 26.7601L73.1399 38.3201L65.5699 25.1101L58.0999 38.3201L47.1699 26.7601"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path d="M63.9102 27.17V72.5" stroke={outline} strokeMiterlimit="10" />
      <path d="M67.3096 27.0601V72.39" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M79.7103 20.53L65.6203 26.41L51.5303 20.53L51.8403 37.71L65.6203 29.87L79.4003 37.71L79.7103 20.53Z"
        fill={secondaryFill}
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6222"
          y1="56.9227"
          x2="65.6222"
          y2="1.0005"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
